import axios from 'axios';

const ACCOUNTS_API_URL = process.env.REACT_APP_ACCOUNTS_API_URL || 'http://localhost:5001/api/accounts';

const accountsApi = axios.create({
  baseURL: ACCOUNTS_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

accountsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('fmas_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

accountsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('fmas_token');
      localStorage.removeItem('fmas_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default accountsApi;
